// src/components/Eventos/EditableNumberCell.js
import React, { useState, useEffect } from 'react';
import { TableCell, TextField, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

export default function EditableNumberCell({
  athlete,
  laneNumber,
  onReplaceAthlete,
  onAddAthlete,
  cellStyle = {},     // Accept cellStyle
  buttonStyle = {}    // Accept buttonStyle
}) {
  const [value, setValue] = useState('');
  const [adding, setAdding] = useState(false);

  useEffect(() => {
    // If athlete exists, show their ID
    setValue(athlete?.idNumber ?? '');
    // Reset adding mode if athlete is removed
    if (!athlete) setAdding(false);
  }, [athlete]);

  const finishAdding = () => {
    const newId = value.trim();
    if (newId) {
      onReplaceAthlete(laneNumber, newId);
    }
    setAdding(false);
  };

  // Apply cellStyle to the TableCell
  return (
    <TableCell align="center" sx={cellStyle}>
      {athlete || adding ? (
        <TextField
          variant="standard"
          value={value}
          onChange={e => setValue(e.target.value)}
          onBlur={finishAdding}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              e.preventDefault();
              finishAdding();
            }
          }}
          placeholder="Dorsal"
          size="small"
          inputProps={{
            style: { 
              textAlign: 'center', 
              width: '3rem',
              // Apply responsive font size from buttonStyle
              fontSize: buttonStyle.fontSize
            }
          }}
        />
      ) : (
        <IconButton
          size="small"
          color="primary"
          onClick={() => setAdding(true)}
          sx={buttonStyle}  // Apply buttonStyle
        >
          <AddIcon />
        </IconButton>
      )}
    </TableCell>
  );
}